import { render, staticRenderFns } from "./ReviewSystem.vue?vue&type=template&id=5f9dd408"
import script from "./ReviewSystem.vue?vue&type=script&lang=js"
export * from "./ReviewSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports